var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h16v16H0z","key":0}),React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"m12.765 10.38-.001.098-.31 2.888a.5.5 0 0 1-.997-.017l.002-.09.136-1.266c-1.75 1.523-4.462 1.771-6.513.505A5.44 5.44 0 0 1 2.5 7.904a.5.5 0 0 1 1-.007 4.43 4.43 0 0 0 2.107 3.75c1.715 1.06 4.01.818 5.427-.495l-1.54.275a.5.5 0 0 1-.556-.317l-.024-.087a.5.5 0 0 1 .317-.556l.087-.024 2.86-.51a.5.5 0 0 1 .587.447m.603-2.176a.5.5 0 0 1-.998-.06 4.44 4.44 0 0 0-2.099-4.05c-1.733-1.071-3.976-.863-5.457.4l1.23-.33a.5.5 0 0 1 .346.934l-.085.03-2.804.76a.5.5 0 0 1-.625-.405l-.006-.088.057-2.905a.5.5 0 0 1 .994-.07l.006.09-.029 1.466c1.796-1.755 4.686-2.1 6.899-.733a5.44 5.44 0 0 1 2.571 4.961","key":1})]));
}

Refresh.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Refresh;

Refresh.default = Refresh;
